import React, { useState, useEffect, useRef } from 'react';
import { withRouter } from "react-router-dom";
import { post, get } from '../../helpers/api_helper';
import { img_view, IsModuleAccess } from '../../helpers/Helper';
import Loader from '../../component/Loader';
import { POST_ADD_BANNER, POST_GET_BANNER_DETAIL } from '../../helpers/url_helper';
import { toast } from 'react-toastify';
import SimpleReactValidator from 'simple-react-validator';
import { Helmet } from "react-helmet";
import { Link, useHistory } from "react-router-dom";

const ChangePassword = props => {
    let history = useHistory();
    if (!IsModuleAccess('banner')) {
        history.push("/");
    }

    const [isLoader, setLoader] = useState(1);
    const simpleValidator = useRef(new SimpleReactValidator());
    const [ButtonDisabled, SetButtonDisabled] = useState(false);
    const [form_inputs, setInputs] = useState({ 'banner_id': 0, 'image': '',type : '',title : '' });
    const [title, setTitle] = useState('Add Banner');
    const [, forceUpdate] = useState();

    useEffect(() => {
        async function get_detaile() {
            if (props.match.params.id) {
                setTitle('Edit Banner');
                var res_data = await post(POST_GET_BANNER_DETAIL, { 'banner_id': props.match.params.id });
                if (res_data.status) {
                    setInputs(res_data.detail);
                } else {
                    toast.error(res_data.message);
                    history.push("/");
                }
            }
            setLoader(1);
        }
        get_detaile();
    }, [props.match.params.id])

    // form submit event
    const handleSubmit = async (event) => {
        event.preventDefault();
        const formValid = simpleValidator.current.allValid()
        console.log(formValid);
        if (!formValid) {
            simpleValidator.current.showMessages(true);
            forceUpdate(1);
        } else {
            SetButtonDisabled(true);
            var res_data = await post(POST_ADD_BANNER, form_inputs);
            if (res_data.status) {
                toast(res_data.message);
                history.push("/banner");
            } else {
                toast.error(res_data.message);
            }
            SetButtonDisabled(false);
        }
    }

    // input text change handler
    const handleInputChange = (event) => {
        event.persist();
        if (event.target.name === 'image') {
            var file_extension = event.target.files[0].name.split('.').pop();
            var file_size = event.target.files[0].size;
            var file_size = (file_size / 1024 / 1024).toFixed(1);

            var extension = ['png', 'jpg', 'jpeg'];
            if (!extension.includes(file_extension.toLowerCase())) {
                toast.error('Alludu only file png, jpg and jpeg.');
                event.target.value = null;
                return false;
            }

            if (file_size > 1) {
                toast.error('Max File size Allowed 1Mb.');
                event.target.value = null;
                return false;
            }

            var file = event.target.files[0];
            var reader = new FileReader();
            reader.onload = function () {
                setInputs(inputs => ({ ...form_inputs, [event.target.name]: reader.result }));
            }
            reader.readAsDataURL(file);
        } else {
            setInputs(inputs => ({ ...form_inputs, [event.target.name]: event.target.value }));
        }
    }


    if (!isLoader) {
        return (<Loader></Loader>);
    }

    return (
        <>
            <Helmet>
                <meta charSet="utf-8" />
                <title>ONDA | {title}</title>
            </Helmet>

            <div className='row mt-3'>
                <div className='col-sm-8'>
                    <div className='card'>
                        <div className="card-header">
                            <h6 className='m-0'>{title}</h6>
                        </div>
                        <div className='card-body'>
                            <form className="av-invalid" onSubmit={handleSubmit}>
                                <div className='row'>
                                    <div className='col-sm-12'>
                                        <div className="form-group mb-3">
                                            <label className="form-label">Select Banner Type </label>
                                            <select name="type" value={form_inputs.type} onChange={handleInputChange} className="form-control" >
                                                <option value="">Select Type</option>
                                                <option value="Footer">Footer</option>
                                                <option value="Home">Home</option>
                                            </select>
                                            {simpleValidator.current.message('type', form_inputs.type, 'required')}
                                        </div>
                                    </div>
                                    <div className='col-sm-12'>
                                        <div className="form-group mb-3">
                                            <label className="form-label">Title </label>
                                            <input name="title" onChange={handleInputChange} value={form_inputs.title} className="form-control" type="text" />
                                        </div>
                                    </div>
                                    <div className='col-sm-12'>
                                        <div className="form-group mb-3">
                                            <label className="form-label">Image <small className='ml-4'>Alludu file png, jpg and jpeg. footer imge Size 300px X 300px Home Banner Size 1920px X 800px</small></label>
                                            <input name="image" onChange={handleInputChange} className="form-control" type="file" accept="image/*" />
                                            {/* {!form_inputs.banner_id && simpleValidator.current.message('Banner', form_inputs.image, 'required')} */}
                                        </div>
                                    </div>
                                </div>
                                <div className="text-center mt-4">
                                    <button disabled={ButtonDisabled} type="submit" className='btn btn-primary c-btn-primary pt-1 pb-1 pl-3 pr-3'>{ButtonDisabled && <i className="fa fa-spinner me-2 fa-spin"></i>} Submit</button>
                                    <Link to="/banner" className='btn btn-danger c-btn-danger ml-3 pt-1 pb-1 pl-3 pr-3'>Cancel</Link>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
export default withRouter(ChangePassword)
